import { render, staticRenderFns } from "./CardIntroduction.vue?vue&type=template&id=387c0cdf"
import script from "./CardIntroduction.vue?vue&type=script&lang=js"
export * from "./CardIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports